<template>
  <div class="sp-countdown">
    <span class="sp-countdown__label">{{ label }}</span>
    <span class="sp-countdown__clock-container">
      <span class="sp-countdown__clock">{{ days }}:{{ hours }}:{{ minutes }}:{{ seconds }}</span>
      <span class="sp-countdown__clock-label">
        <span>Days</span>
        <span>Hours</span>
        <span>Min<span>utes</span></span>
        <span>Sec<span>onds</span></span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: "SpCountdown",

  props: {
    label: {
      type: String,
      required: true,
      default: "Days until event",
    },
    date: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      remainingSeconds: 0,
    };
  },

  computed: {
    days() {
      return Math.max(0, Math.floor(this.remainingSeconds / 86400));
    },

    hours() {
      return Math.max(0, Math.floor((this.remainingSeconds % 86400) / 3600))
        .toString()
        .padStart(2, "0");
    },

    minutes() {
      return Math.max(0, Math.floor((this.remainingSeconds % 3600) / 60))
        .toString()
        .padStart(2, "0");
    },

    seconds() {
      return Math.max(0, this.remainingSeconds % 60)
        .toString()
        .padStart(2, "0");
    },
  },

  mounted() {
    const countdownDate = new Date(this.date);
    const now = new Date();
    const timeDifference = Math.floor((countdownDate - now) / 1000);

    this.remainingSeconds = timeDifference;

    setInterval(() => {
      this.remainingSeconds--;
      if (this.remainingSeconds < 0) {
        clearInterval(this.interval);
      }
    }, 1000);
  },
};
</script>

<style>
:host {
  display: block;
}

.sp-countdown {
  --countdown-font: var(--sp-sys-typescale-body-bold-short, inherit);
  --countdown-label-font-size: var(--sp-ref-size-20, 2.5rem);
  --countdown-label-font-size-mobile: var(--sp-ref-size-15, 1.875rem);
  --countdown-clock-font-size: var(--sp-ref-size-30, 3.75rem);
  --countdown-clock-font-size-mobile: var(--sp-ref-size-15, 1.875rem);
  --countdown-clock-label-font-size: var(--sp-ref-size-10, 1.25rem);
  --countdown-clock-label-font-size-mobile: var(--sp-ref-size-8, 1rem);
  --countdown-gap: var(--sp-ref-spacing-3, 0.375rem);
  --countdown-clock-margin: var(--sp-ref-spacing-8, 1rem);

  /* Stacked in column, until other variants are designed */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--countdown-gap);

  font: var(--countdown-font);
}

.sp-countdown__clock-container {
  display: flex;
  flex-direction: column;
}

.sp-countdown__label {
  font-size: var(--countdown-label-font-size);
}

.sp-countdown__clock {
  font-size: var(--countdown-clock-font-size);
}

.sp-countdown__clock-label {
  display: flex;
  font-size: var(--countdown-clock-label-font-size);
  gap: var(--countdown-gap);
  margin-inline: var(--countdown-clock-margin) * -1;
}

.sp-countdown__clock-label > span {
  flex: 1;
  text-align: center;
}

@media (max-width: 750px) {
  .sp-countdown__label {
    font-size: var(--countdown-label-font-size-mobile);
  }

  .sp-countdown__clock {
    font-size: var(--countdown-clock-font-size-mobile);
  }

  .sp-countdown__clock-label {
    font-size: var(--countdown-clock-label-font-size-mobile);
  }

  /* Hide selected text and add dot */
  .sp-countdown__clock-label span span {
    display: none;
  }

  .sp-countdown__clock-label span:has(span)::after {
    content: ".";
  }
}
</style>
